// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { addEventListener } from '../../../../eventListeners';
import { assertIsInitialized } from '../../../errors/errorHelpers';
export const onNotificationOpened = input => {
    assertIsInitialized();
    return addEventListener('notificationOpened', input);
};
